import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';

import { BaasAppState, BarIdpClient } from '@lvflanders/bar';
import { BarCoreService } from '@lvflanders/bar-ng';
import { BarI18nPipe } from '@lvflanders/bar-ng-ui';

import { StartschermV2StateService } from '../../services/v2/startscherm-v2-state.service';
import { StartschermTestProfileDialog, StartschermTestProfileDialogData } from './startscherm-test-profile-dialog/startscherm-test-profile-dialog';

@Component({
    selector: 'startscherm-test-profile-widget',
    templateUrl: './startscherm-test-profile-widget.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BarI18nPipe]
})
export class StartschermTestProfileWidget implements OnInit {
    readonly #appState = inject(BaasAppState);
    readonly #core = inject(BarCoreService);
    readonly #dialog = inject(MatDialog);
    readonly #barIdpClient = inject(BarIdpClient);
    readonly #state = inject(StartschermV2StateService);
    readonly #destroyRef = inject(DestroyRef);
    // test profiel name
    protected readonly testProfiel = signal<string | undefined>(undefined);
    protected readonly isVisible = signal(false);

    ngOnInit(): void {
        this.#core.refreshed.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.#init());
        this.#init();
    }

    // invoked when user opens the popup
    protected search(): void {
        const dialogRef = this.#dialog.open(StartschermTestProfileDialog, {
            minWidth: '70vw',
            data: (!this.#appState.toepassing.code.includes('STA2')
                ? { toepassingscode: this.#appState.toepassing.code }
                : {}) as StartschermTestProfileDialogData
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe(async (result) => {
                if (result && result.data.result === 'OK') {
                    this.#barIdpClient.authenticateWithTestProfiel(result.data.testProfielSelected);
                }
            });
    }

    protected async reset(): Promise<void> {
        await this.#barIdpClient.authenticate();
    }

    #init(): void {
        this.isVisible.set(this.#state.isIntern && (this.#state.isDEV || this.#state.isTST));

        if (!this.#appState.basiscontext.testProfiel) {
            if (this.#appState.basiscontext.fullUsername.indexOf(`#`) > 0) {
                this.testProfiel.set(this.#appState.basiscontext.fullUsername);
            }
        } else {
            this.testProfiel.set(this.#appState.basiscontext.testProfiel);
        }
    }
}
